var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.641 0H61.36c.686 0 1.358.196 1.939.564A3.66 3.66 0 0164.64 2.08a3.687 3.687 0 01-.44 3.878L40.589 35.662c-.518.65-.8 1.458-.801 2.292v18.88a3.685 3.685 0 01-1.458 2.933l-7.287 5.5a3.631 3.631 0 01-3.816.346 3.652 3.652 0 01-1.47-1.352 3.683 3.683 0 01-.545-1.928V37.95a3.682 3.682 0 00-.801-2.288L.799 5.958A3.679 3.679 0 01.36 2.08 3.66 3.66 0 011.702.564 3.627 3.627 0 013.642 0z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default ForwardRef;